import { render, staticRenderFns } from "./CabinType.vue?vue&type=template&id=4177d379&"
import script from "./CabinType.vue?vue&type=script&lang=js&"
export * from "./CabinType.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports